import { render, staticRenderFns } from "./MovePort.vue?vue&type=template&id=4b8df9d0"
import script from "./MovePort.vue?vue&type=script&lang=js"
export * from "./MovePort.vue?vue&type=script&lang=js"
import style0 from "./MovePort.vue?vue&type=style&index=0&id=4b8df9d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports